import axios from 'axios'
import { AuthResponse } from './models';
import { TokenStorage } from './TokenStorage';


export const baseUrl = () => {
    return `${process.env.REACT_APP_AUTH_API}`;
} 

export const isAuth = async (): Promise<boolean> => {
    return await TokenStorage.isAuthenticated();
}

export const logout = ()=> {
    TokenStorage.clear();
}

export async function login(username: string, password: string): Promise<boolean> {
    return axios.post<AuthResponse>(
        `${baseUrl()}/login`,
        { username: username, password: password}
    ).then(res => {
        TokenStorage.storeTokens(res.data); 
        return true;
    }).catch(err => {
        return Promise.reject(false);
    });
}

export async function refresh(tokens: AuthResponse): Promise<boolean> {
    return axios.post<AuthResponse>(
        `${baseUrl()}/refresh`,
        { accessToken: tokens.accessToken, refreshToken: tokens.refreshToken}
    ).then(res => {
        TokenStorage.storeTokens(res.data); 
        return true;
    }).catch(err => {
        return Promise.reject(false);
    });
}

export async function getUser(email: string): Promise<boolean> {
    return axios.get<AuthResponse>(
        `${baseUrl()}/${email}`
    ).then(res => {
        return true;
    }).catch(err => {
        return Promise.reject(false);
    });
}

export async function sendEmail(email: string): Promise<boolean> {
    return axios.get<AuthResponse>(
        `${baseUrl()}/sendmail/${email}`
    ).then(res => {
        TokenStorage.storeResetPassToken(res.data);
        return true;
    }).catch(err => {
        return Promise.reject(false);
    });
}

export async function changePassword(email: string, password: string): Promise<boolean> {
    const token : any = TokenStorage.getResetPassToken()
    const config = {
        headers: { Authorization: `Bearer ${token}`}
    };
    
    return axios.put<AuthResponse>(
        `${baseUrl()}/changePassword`,
        {email, password}, 
        config
    ).then(res => {
        TokenStorage.clearResetToken();
        return true;
    }).catch(err => {
        return Promise.reject(false);
    });
}